var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmarkRounded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37px",
    height: "37px",
    viewBox: "0 0 37 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Games/Questions/New",
    transform: "translate(-935.000000, -1738.000000)",
    fill: "#93D578",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section/TableBox",
    transform: "translate(340.000000, 108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(51.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Statement-Copy-2",
    transform: "translate(40.000000, 1589.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Preview",
    transform: "translate(399.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(17.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.770865,1.08657519 C105.446782,-1.59475012 96.9873943,0.81978682 92.0978868,6.8593383 C87.2647481,12.8292832 86.6299054,21.4473563 90.6035169,28.0410454 C94.5770376,34.6344362 102.331085,38.061363 109.880855,36.7078139 C118.665611,35.1329074 124.826812,27.2832571 125,18.5071165 C124.846715,10.7413629 120.126037,3.7791839 112.770865,1.08657519 Z M102.860389,25.3959414 L99.961527,22.7456331 L99.961527,22.7456331 C96.5519858,19.3742784 99.568932,22.481864 96.1594592,19.1105105 C94.6168854,17.5852797 97.010407,15.2198378 98.5523032,16.7444661 C101.961776,20.1158196 100.132727,18.2544474 103.542269,21.6257332 C106.95181,18.2544474 110.361281,14.883159 113.770755,11.5118055 C115.313328,9.98650837 117.705496,12.3532216 116.163599,13.8778499 C112.754125,17.2492034 110.780502,19.0733375 107.370961,22.4446923 L104.217589,25.3888418 C103.83629,25.7448424 103.245391,25.7479334 102.860389,25.3959414 Z",
    id: "Shape"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkRounded);
export default __webpack_public_path__ + "static/media/checkmark-rounded.83dda0a27f80b8ac1b6950037cde36dc.svg";
export { ForwardRef as ReactComponent };